<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="statistics-manage">
    <el-card shadow="never" class="statistics-card">
      <el-tabs v-model="activeTab" class="statistics-tabs" @tab-click="onTabChange">
        <el-tab-pane label="日营业额" name="daily">
          <DailyRevenue v-if="activeTab === 'daily'" />
        </el-tab-pane>
        <el-tab-pane label="区间营业额" name="period">
          <PeriodRevenue v-if="activeTab === 'period'" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import DailyRevenue from '@/components/DailyRevenue.vue'
import PeriodRevenue from '@/components/PeriodRevenue.vue'

const activeTab = ref('daily') // 默认显示期间营业额

const onTabChange = () => {
  // 可选：切换标签页时重置组件状态（组件内部会自己管理）
}
</script>

<style scoped>
.statistics-manage {
  width: 100%;
}
.statistics-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.statistics-tabs {
  margin-top: 8px;
}
</style>